import { ATTENDANCE_MODES } from 'shared/constants/schedule.constants';
import { ROUTES } from 'shared/constants/routes';

export const EVENT_PARAM = 'event';
export const SOURCE_PARAM = 'from';
export const SOURCE_REPORT = 'report';

/**
 * Path to the educational-events page focused on a single event, via the
 * `?event=` selection param the page reads on load.
 *
 * `fromReport` adds `?from=report`. The report tables link to this same
 * pathname, so the navigation tracker sees no path change and clears any
 * click-time analytics context — the marker rides in the URL instead so the
 * page-view event can still be attributed to the report.
 * @param {string} eventId
 * @param {{ fromReport?: boolean }} [options]
 * @returns {string}
 */
export function eventDetailsPath(eventId, { fromReport = false } = {}) {
  const params = new URLSearchParams({ [EVENT_PARAM]: eventId });
  if (fromReport) params.set(SOURCE_PARAM, SOURCE_REPORT);
  return `${ROUTES.EDUCATIONAL_EVENTS}?${params}`;
}

export {
  getHostIds,
  resolveHostName,
  resolveHosts,
  isCurrentUserHost,
  isHostOrAdmin,
  isCheckInEligibleToday,
  getEventStartDayOffset,
  isCheckInSessionOpen,
  getCheckInSchedule,
  isUpcomingEvent,
  isPastEvent,
  canSelfAttest,
  getCheckInMethodLabel,
  getCheckInModeFromEvent,
  isStaticQr,
} from 'shared/utils/event-view.helpers';

export function attendanceModeLabel(mode, lang) {
  const labels = {
    [ATTENDANCE_MODES.VIRTUAL]: lang.FORMAT_VIRTUAL,
    [ATTENDANCE_MODES.HYBRID]: lang.FORMAT_HYBRID,
    [ATTENDANCE_MODES.IN_PERSON]: lang.FORMAT_IN_PERSON,
  };
  return labels[mode] ?? lang.FORMAT_IN_PERSON;
}

/**
 * Message for a failed report export, distinguishing a permission failure (403)
 * — where retrying won't help — from transient/unknown errors.
 * @param {unknown} error
 * @param {Record<string, string>} lang EDUCATIONAL_EVENTS lang section
 * @returns {string}
 */
export function exportErrorMessage(error, lang) {
  return error?.response?.status === 403 ? lang.REPORT_EXPORT_FORBIDDEN : lang.REPORT_EXPORT_FAILED;
}
